<template> 
    <div>
        <div :id="id" style="width:100%; height:220px;"></div>
        <div>
            <el-row type="flex" class="row-bg" justify="space-around">
                <el-col :span="6"></el-col>
                <el-col :span="5">
                机房总耗电
                </el-col>
                <el-col :span="4">
                {{ systemPueTotalData.recordRoom ? systemPueTotalData.recordRoom : 0 }}
                </el-col>
                <el-col :span="3">
                kW·h
                </el-col>
                <el-col :span="6"></el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="space-around">
                <el-col :span="6"></el-col>
                <el-col :span="5">
                IT总负载
                </el-col>
                <el-col :span="4">
                {{ systemPueTotalData.recordIT ? systemPueTotalData.recordIT : 0 }}
                </el-col>
                <el-col :span="3">
                kW·h
                </el-col>
                <el-col :span="6"></el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="space-around">
                <el-col :span="6"></el-col>
                <el-col :span="5">
                总用水量
                </el-col>
                <el-col :span="4">
                {{ totalWaterCost ? totalWaterCost : 0 }}
                </el-col>
                <el-col :span="3">
                TON
                </el-col>
                <el-col :span="6"></el-col>
            </el-row>
            <el-row type="flex" class="row-bg" justify="space-around">
                <el-col :span="6"></el-col>
                <el-col :span="5">
                抄表PUE
                </el-col>
                <el-col :span="4">
                {{manualPUE ? manualPUE : 0 }}
                </el-col>
                <el-col :span="3">
                </el-col>
                <el-col :span="6"></el-col>
            </el-row>
        </div>
    </div>
</template>

<script type="text/javascript">

import Big from 'big.js';
import echarts from "echarts";

import { uuid8 } from "@/util/common";

export default {
    name: 'pue.report.pue.total.echarts',
    components:{
    },
    props: {
        systemPueTotalData:Object,
        manualPueTotalData:Object,
        title : {
            type: String,
            default() {
                return "PUE数据汇总";
            }
        }
    },    
    data: () => {
        return {
            id : uuid8(),
        };
    },
    mounted: function () {
    
        const me = this;
        
        me.renderEcharts();
    },
    watch: {
    
        systemPueTotalData: {
        
            handler: function(newValue, oldValue) {
                
                const me = this;
                
                me.renderEcharts();
            },
            deep : true
        }
        
    },
    computed: {
        totalWaterCost() {
            
            const me = this;
        
            if( me.manualPueTotalData && me.manualPueTotalData.waterCost ){
                return me.manualPueTotalData.waterCost;
            }
            
            return null;
        },
        manualPUE(){
        
            const me = this;
        
            if( me.manualPueTotalData && me.manualPueTotalData.puePhase ){
                return me.manualPueTotalData.puePhase.toFixed(2);
            }
            
            return null;
        }
    },
    methods: {
        handleSizeChange(val) {
                        
            const me = this;
        },
        renderEcharts(){
        
            const me = this;
        
            let totalPUEShow = new Big(3);
  	        
  	        let averagePUEBig = me.systemPueTotalData.puePhase ? me.systemPueTotalData.puePhase : new Big(0) ;
  	        let averagePUEString = averagePUEBig ? averagePUEBig.toFixed(2) : 0 ;
  	        
  	        let puepercentage         = averagePUEBig.div( totalPUEShow );
  	        let puePercentageString   = puepercentage.toFixed(2);
  	        
  	        let colorShow = "#36ce9b";
  	        if( puepercentage > 0.7 ){
  	            colorShow = "#ee5b56";
  	        }
  	        
  	        var myChart = echarts.init(document.getElementById( me.id ));
            let option = {
                "toolbox": {
                    "show": false,
                    "feature": {
                        "mark": {
                            "show": true
                        },
                        "restore": {
                            "show": true
                        },
                        "saveAsImage": {
                            "show": true
                        }
                    }
                },
                "series": [{
                    "name": "本周PUE",
                    "type": "gauge",
                    "startAngle": 180, //总的360，设置180就是半圆
                    "endAngle": 0,
            		min:0,
                    max:3,		
            		splitNumber:1,
                    "center": ["50%", "80%"], //整体的位置设置
                    "radius": 120,
                    "axisLine": {
                        "lineStyle": {
                            "width": 30, //柱子的宽度
                           color: [
                                [ puePercentageString , colorShow ],
                                [1, '#576d85']] //0.298是百分比的比例值（小数），还有对应两个颜色值
                        }
                    },
            		axisLabel: {
            			show: true,
            			padding:[20,0,0,0]
                       },
            		"axisTick": {
                       length:0, 
                    },
                    "splitLine": {
                        length:0, 
                    },
                    "pointer": {"show": false
                    },
                    "title": {
                        "show": true,
                        "offsetCenter": [0, "-120%"], //标题位置设置
                        "textStyle": { //标题样式设置
                            "fontSize": 15,
                            "fontFamily": "微软雅黑",
                        }
                    },
                    "detail": {
            			    show: true,
                            offsetCenter: [0, '-20%'],
                            textStyle: {
                            fontSize: 20,
            				color:'#000000'
                            }},
                    "data": [{ //显示数据
                        "value": averagePUEString,
                        "name": me.title
                    }]
                }]
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }
    }
}

</script>